import { Container, Typography } from "@material-ui/core"
import { useRouter } from "next/router"
import { Dispatch, SetStateAction, useEffect, useRef } from "react"
import styled from "styled-components"
import glass from "../../../../public/animation/glass.json"

import GenericButton from "components/GenericButton/GenericButton"
import dynamic from "next/dynamic"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled(Container)`
  height: 100vh;
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 50px;
  margin-top: 35px;
  line-height: 0.8;
  color: #000;
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 10px;
  line-height: 0.92;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 22px;
  }
`

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const StyledGenericButton = styled(GenericButton)`
  margin-top: 40px;
`

const StyledLottie = styled(Lottie)`
  height: 50%;
`

type FailPaymentProps = {
  title?: string
  text?: string
  link?: string
  setPaymentSteps?: Dispatch<SetStateAction<number>>
  setIframeLink?: Dispatch<SetStateAction<string>>
  retry?: () => void
  setRefList?: Dispatch<SetStateAction<any[]>>
}

const FailPayment = ({
  title = "אופסי, משהו השתבש בדר",
  text = "אם הבעיה ממשיכה אפשר לפנות לשירות לקוחות.",
  link = "/",
  setPaymentSteps,
  setIframeLink,
  retry,
  setRefList,
}: FailPaymentProps) => {
  const router = useRouter()
  const Section1Ref = useRef(null)

  useEffect(() => {
    setRefList && setRefList([Section1Ref])
  }, [])

  const handleRetry = () => {
    if (retry) {
      retry()
    } else if (link) {
      if (link === "/payment" || link === "/groupPurchases/payment") {
        setPaymentSteps(1)
        setIframeLink(null)
      } else {
        router.push(link)
      }
    } else {
      router.back()
    }
  }

  return (
    <StyledWrapper ref={Section1Ref}>
      <StyledLottie animationData={glass} loop={false} />
      <StyledTitle>{title}</StyledTitle>
      <StyledText>{text}</StyledText>
      <StyledButtonContainer>
        <StyledGenericButton
          onClick={handleRetry}
          btnType="filled"
          mobileWidth={238}
        >
          בואו ננסה שוב
        </StyledGenericButton>
      </StyledButtonContainer>
    </StyledWrapper>
  )
}

export default FailPayment
